<table class="mtx-calendar-table" role="grid">
  <thead class="mtx-calendar-table-header"></thead>
  <tbody mtx-calendar-body
         (@slideCalendar.done)="_calendarStateDone()"
         [@slideCalendar]="_calendarState"
         [label]="_yearLabel"
         [rows]="_months"
         [todayValue]="_todayMonth!"
         [labelMinRequiredCells]="2"
         [numCols]="4"
         [activeCell]="_adapter.getMonth(activeDate)"
         [selectedValue]="_selectedMonth!"
         (selectedValueChange)="_monthSelected($event)"
         [allowDisabledSelection]="true"></tbody>
</table>
